import React from 'react';
import { Drug, PrescriptionPrintProps } from './index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PrescriptionPrint = React.forwardRef((props: PrescriptionPrintProps, ref: any) => {
	const { medicines } = props.prescription;
	const patient = props.patient;
	const now = new Date();
	const nameMargin = 'mr-16';

	const removeDrug = (index: number) => {
		const newDrugs = [...medicines];
		newDrugs.splice(index, 1);
		// prompt to make sure
		if (window.confirm('آیا مطمئن هستید؟')) {
			props.setPrescription({ ...props.prescription, medicines: newDrugs });
		}
	};

	const renderDrug = (drug: Drug) => {
		switch (drug.kind) {
			case 'default':
				return (
					<>
						<span style={{ wordSpacing: 8 }}>{drug.drugName} </span> <span className="ml-2" /> #{' '}
						{'        '}
						{drug.drugDose} {' - '}
						<span style={{ direction: 'rtl' }}>
							{' '}
							{drug.drugFrequency} {drug.drugDuration && '-'} {drug.drugDuration}
						</span>
					</>
				);
			case 'construction':
				return (
					<div>
						{drug.content?.map((item, index) => (
							<div key={index}>
								{item}
								<span />
							</div>
						))}
					</div>
				);
		}
	};

	return (
		<div
			ref={ref}
			style={{ direction: 'rtl' }}
			className="mt-3 ml print:ml-48 print:mt-9 print:text-sm"
		>
			<div className="print:mr-6">
				<div className="grid grid-cols-2 ">
					<h1 className={`mb-1 text-right  ${nameMargin} `}>
						{patient.firstName} {patient.lastName}
					</h1>
					{/* stick h1 to left */}
					{patient.national_id && (
						<h1 className="ml-12 text-xs text-left">کد ملی: {patient.national_id}</h1>
					)}
				</div>
				<h2 className={`${nameMargin}`}>{now.toLocaleDateString('fa')} </h2>
			</div>
			<ol style={{ direction: 'ltr' }} className="print:mt-20">
				{medicines.map((drug, index: number) => (
					<li
						className="mb-5 ml-12 list-decimal print:text-base "
						style={{ direction: 'ltr' }}
						key={index}
					>
						{renderDrug(drug)}
						<button
							className="p-1 m-1 text-sm text-red-700 rounded-lg shadow-lg bold print:hidden"
							onClick={() => removeDrug(index)}
						>
							X
						</button>
					</li>
				))}
			</ol>
		</div>
	);
});

PrescriptionPrint.displayName = 'PrescriptionPrint';
